module.exports = __webpack_public_path__ + "static/img/实验室安全检查2.59ebc10.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/实验室安全检查2.png
// module id = vVtE
// module chunks = 13